export default __webpack_public_path__ + "static/trade-40b3a4549fbcd3d1ae8417e6436a11be.png";